const FETCH_INSUR_SUBCAREERS_REQUEST = "FETCH_INSUR_SUBCAREERS_REQUEST";
const FETCH_INSUR_SUBCAREERS_SUCCESS = "FETCH_INSUR_SUBCAREERS_SUCCESS";
const FETCH_INSUR_SUBCAREERS_FAILURE = "FETCH_INSUR_SUBCAREERS_FAILURE";

export default {
  FETCH_INSUR_SUBCAREERS_REQUEST,
  FETCH_INSUR_SUBCAREERS_SUCCESS,
  FETCH_INSUR_SUBCAREERS_FAILURE,
};
